import React, {Component, PropTypes} from 'react'
import VirtualList from './VirtualList'
import NewsCell from 'elements/NewsCell'
import EmptySearch from 'elements/EmptySearch'
import ReactHeight from 'react-height'
import store from 'state/store'
import underscore from 'underscore'

// here we store the cell heights measured by react-height, we use them for the dynamic row heights
const heights = {}
class NewsList extends Component {
	// here we give some more time for the recomputeRowHeights before component updates
	componentDidMount() {this.t = setTimeout(() => this.forceUpdate(), 1000)}
	componentWillUnmount() {clearTimeout(this.t)}
	render() {
		const {onOpen, newsPosition, list, noResults, filter, isPhone, isTablet} = this.props
		const self = this

		// A hacky way to prevent flickering of news list
		const catGen = store.getState().categories._gen
		const srcGen = store.getState().sources._gen
		let b1 = catGen
		let b2 = srcGen

		// TODO: check why store.getState().categories._gen and store.getState().sources._gen
		// have issues on deployed code, while work perfectly on development
		// for now this fixes the news listing, as side efect the no results also appear
		// while page is loading.
		const contentFooterFetched = Boolean(b1 && b2)	// Boolean(catGen && srcGen)
		const listVisible = list.length > 0 || (list.length == 0 && !underscore.isEmpty(filter))	// contentFooterFetched

		return (
			<VirtualList
				visible={listVisible}
				ref={el => {
					self.listEl = el
					self.listEl && self.listEl.recomputeRowHeights()
				}}
				count={list.length}
				rowWidth={320}
				scrollPosition={newsPosition}
				row={({index}) => {
					const item = list[index]
					const id = item._id
					const date = item.pubStart
					const teaser = item.teaser
					const title = item.title
                    const content = item.content
                    const sourceIds = item.sourceIds
					return (
						<ReactHeight
							onHeightReady={height => {
								if (heights[id] === height) {return}
								heights[id] = height
								self.listEl && self.listEl.recomputeRowHeights(index)
							}}
						>
							<NewsCell
								date={date}
								id={id}
								isActive={index === newsPosition}
								isFirst={index === 0}
								isLast={index === list.length - 1}
								newsPosition={newsPosition}
								onOpen={onOpen}
								teaser={teaser}
								content={content}
                                title={title}
                                sourceIds={sourceIds}
							/>
						</ReactHeight>
					)}
				}
				rowHeight={i => {
					return heights[list[i.index]._id] || 150}}
                noRows={() => <EmptySearch>{noResults}</EmptySearch>}
                isPhone={isPhone}
                isTablet={isTablet}
			/>
		)
	}
}
export default NewsList



// WEBPACK FOOTER //
// ./elements/NewsList.jsx